function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.436 2.61417C13.341 2.21814 11.878 2 10.3168 2C8.75559 2 7.29256 2.21826 6.19762 2.61447C5.24132 2.96061 4.67041 3.41232 4.67041 3.82327C4.67041 4.23423 5.24132 4.68585 6.19766 5.03181C7.29256 5.42806 8.75547 5.64633 10.3168 5.64633C11.8781 5.64633 13.341 5.42806 14.436 5.03181C15.3922 4.68568 15.9632 4.23397 15.9632 3.82297C15.9632 3.41197 15.3922 2.96043 14.436 2.61417Z",
  fill: "#99A6B0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3164 14.5529C8.10335 14.5529 5.78804 14.0957 4.66675 13.2296V16.1766C4.66675 16.5876 5.2396 17.0396 6.19577 17.3856C7.29041 17.7817 8.75538 17.9998 10.3172 17.9998C11.236 18.0032 12.1531 17.9211 13.0567 17.7546C14.7687 17.4261 15.966 16.7772 15.966 16.1766V13.2296C14.8447 14.0957 12.5294 14.5529 10.3164 14.5529ZM11.3083 16.5549H9.32444C9.13391 16.5549 8.97943 16.4005 8.97943 16.2099C8.97943 16.0194 9.13391 15.8649 9.32444 15.8649H11.3083C11.4988 15.8649 11.6533 16.0194 11.6533 16.2099C11.6533 16.4005 11.4988 16.5549 11.3083 16.5549Z",
  fill: "#99A6B0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3164 10.4443C8.10335 10.4443 5.78804 9.98709 4.66675 9.12101V12.0394C4.66675 12.4504 5.2396 12.9024 6.19577 13.2484C7.29041 13.6445 8.75538 13.8626 10.3172 13.8626C11.879 13.8626 13.3427 13.6445 14.4373 13.2484C15.3935 12.9025 15.966 12.4505 15.966 12.0394V9.12097C14.8447 9.98704 12.5294 10.4443 10.3164 10.4443ZM11.3083 12.3714H9.32444C9.13391 12.3714 8.97943 12.217 8.97943 12.0264C8.97943 11.8359 9.13391 11.6814 9.32444 11.6814H11.3083C11.4988 11.6814 11.6533 11.8359 11.6533 12.0264C11.6533 12.217 11.4988 12.3714 11.3083 12.3714Z",
  fill: "#99A6B0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3164 6.33702C8.10335 6.33702 5.78804 5.87974 4.66675 5.01367V7.93206C4.66675 8.34315 5.2396 8.79516 6.19577 9.14112C7.29041 9.53724 8.75538 9.75533 10.3172 9.75533C11.879 9.75533 13.3427 9.53724 14.4373 9.14112C15.3935 8.79516 15.966 8.34315 15.966 7.93206V5.01367C14.8447 5.87974 12.5294 6.33702 10.3164 6.33702ZM11.3083 8.31856H9.32444C9.13391 8.31856 8.97943 8.16408 8.97943 7.97355C8.97943 7.78302 9.13391 7.62854 9.32444 7.62854H11.3083C11.4988 7.62854 11.6533 7.78302 11.6533 7.97355C11.6533 8.16408 11.4988 8.31856 11.3083 8.31856Z",
  fill: "#99A6B0"
});

const SvgDiskUsageIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiskUsageIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disk-usage-icon.9d2ebe36.svg";
export { ForwardRef as ReactComponent };